/*
	element-ui 配置文件
	按需求导入对应组件
*/
import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import { Button, Select, Message, Cascader, Option } from "element-ui";
Vue.use(Button);
Vue.use(Select);
Vue.use(Cascader);

Vue.use(Option);
//全局方法
Vue.prototype.$message = Message;
